import React from 'react';
import PropTypes from 'prop-types';
import { WithIconRounded } from 'Components/ProfileMultiProduct/components/designSystem';

const MovementsIcon = ({
  className,
  color,
  containerColor,
  containerSize,
  onClick,
  round,
  size,
}) => (
  <WithIconRounded
    className={className}
    containerColor={containerColor}
    containerSize={containerSize}
    onClick={onClick}
    round={round}
  >
    <svg width={size} height={size} viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.375 9.04167L15.5 13.1667L11.375 17.2917L10.1967 16.1133L12.31 13.9992L1.33333 14V12.3333H12.31L10.1967 10.22L11.375 9.04167ZM4.625 0.708333L5.80333 1.88667L3.69 4H14.6667V5.66667H3.69L5.80333 7.78L4.625 8.95833L0.5 4.83333L4.625 0.708333Z" fill={color} />
    </svg>

  </WithIconRounded>
);

MovementsIcon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  containerColor: PropTypes.string,
  containerSize: PropTypes.number,
  onClick: PropTypes.func,
  round: PropTypes.bool,
  size: PropTypes.number,
};

MovementsIcon.defaultProps = {
  className: 'k-ds-bg-color-light-grey-300',
  color: '#949BA8',
  containerColor: null,
  containerSize: 40,
  onClick: null,
  round: false,
  size: 16,
};

export default MovementsIcon;
